export const getVisitedTabIndicatorKey = <T extends string>(
  pathname: T
): `${T}_visited` => {
  return `${pathname}_visited`;
};
